import { homeAdvantages } from '@/mocks/home';

export default function AdvantagesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              为什么选择我们
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-5">
              四大核心优势，<br />打造卓越服务体验
            </h2>
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-8">
              qiaojzx.cn 从安全、效率、覆盖面和服务质量四个维度持续深耕，确保每一位用户都能获得超出预期的使用体验。
            </p>
            <div className="flex flex-col gap-4">
              {homeAdvantages.map((adv) => (
                <div key={adv.id} className="flex items-start gap-4 p-4 rounded-lg hover:bg-background-50 transition-colors">
                  <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className={`${adv.icon} text-accent-600 text-lg`}></i>
                  </div>
                  <div>
                    <h3 className="font-heading font-semibold text-foreground-900 text-sm">{adv.title}</h3>
                    <p className="text-foreground-500 text-xs mt-1 leading-relaxed">{adv.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20abstract%20geometric%20shapes%20in%20warm%20amber%20and%20cream%20tones%2C%20floating%20translucent%20layers%20with%20soft%20gradient%20overlays%2C%20minimalist%20technology%20concept%20illustration%2C%20subtle%20grid%20patterns%20and%20flowing%20curves%2C%20professional%20corporate%20aesthetic%2C%20clean%20and%20elegant%20atmosphere%2C%20no%20text%20elements&width=1200&height=900&seq=advantage-hth-2026&orientation=landscape"
                alt="qiaojzx.cn 服务优势"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}